import { SchemaValidationError } from '@helpers';
import { config } from '@terminal/config';
import { Tracking } from '@terminal/services/tracking';
import { ZodError, ZodIssue, ZodSchema } from 'zod';

export type ValidateResponseSchemaProps<T> = {
  data: T;
  endpoint: string;
  schema: ZodSchema<T>;
};

export const validateResponseSchema = <T>({
  data,
  endpoint,
  schema,
}: ValidateResponseSchemaProps<T>): SchemaValidationError | false => {
  try {
    schema.parse(data);
    return false;
  } catch (error) {
    if (error instanceof ZodError) {
      const flattenedError = error.flatten((issue: ZodIssue) => ({
        message: issue.message,
        errorCode: issue.code,
        path: issue.path,
      }));

      const validationError = new SchemaValidationError(
        endpoint,
        flattenedError
      );

      const isLocal = config.app.isLocalEnvironment;
      const isProd = config.app.environment === 'prod' && !isLocal;
      const isStaging = config.app.environment === 'staging' && !isLocal;

      if (isProd || isStaging) {
        Tracking.captureException(error, {
          endpoint,
        });
      }

      if (isStaging || isLocal) {
        console.error('Zod schema validation error:', {
          error,
          endpoint,
        });
      }

      return validationError;
    }

    throw error as Error;
  }
};
